<div class="offers-dialog d-flex flex-wrap justify-content-center align-items-center hide theme-interface"
    #offersDialog>
    <div class="selection-container position-absolute">
        <div class="header-container d-flex flex-wrap">
            <div class="w-100">
                <div class="font-size-header pb-4 font-weight-bold theme-color-header">
                    {{'public.checkout.errors.orderSubmissionFailed' | translate}}
                    <span
                        class="float-right position-absolute closebutton text-decoration-underline font-weight-bold theme-color-header"
                        (click)="dismissOffersDialog()">{{'public.global.close'
                        | translate}}<i class="fas fa-times pl-2 theme-color-header"></i></span>
                </div>
                <div class="font-size-primary">
                    {{'public.checkout.errors.ORDER_RESERVABLE_ITEM_QUANTITY_EXCEEDED' | translate}}
                </div>
            </div>
        </div>
        <div class="offers-container pt-2">
            <div class="item-list">
                <div class="item-wrapper text-select-none d-flex flex-column" *ngFor="let offer of unavailableOffers">
                    <div class="item flex-fill mb-3 text-unselectable">
                        <div class="p-0 mb-0 font-size-primary font-weight-bold theme-color-header">•
                            {{offer.offerName}}</div>
                    </div>
                </div>
            </div>
            <div class="font-size-primary float-right text-unselectable">
                <a href="#" class="btn theme-dark btn-dark px-5 py-1" (throttledClick)="updateOrder($event)"
                    appPreventDoubleClick [throttleTime]="5000">
                    {{'public.checkout.updateOrder' | translate}}
                </a>
            </div>
        </div>
    </div>
</div>